import {transparentize} from 'polished';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {EventHandler} from '../../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {ChromelessButton} from '../../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {InteractiveListItem} from '../../../../../../libs/shared/ui/src/components/interactiveList/interactiveListItem';
import {VisuallyHidden} from '../../../../../../libs/shared/ui/src/components/visuallyHidden/visuallyHidden';
import {center} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {SearchSuggestionsBaseProps} from '../../../../../../srcCommon/inboxes/search/searchSuggestionsHelpers';

/*
 * Props.
 */

interface InboxesSearchSuggestionsDropdownExpandButtonProps extends SearchSuggestionsBaseProps {
  isExpanded: boolean;
  onToggleExpand: EventHandler;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  position: relative;
  flex-shrink: 0;
  padding: 0 16px 16px 16px;
  /* Top fade. */
  &::after {
    content: '';
    position: absolute;
    top: -16px;
    left: 0;
    width: calc(100% - 16px);
    height: 16px;
    background-image: linear-gradient(
      ${(p) => transparentize(1, p.theme.foreground)},
      ${(p) => p.theme.foreground}
    );
  }
`;

const StyledExpandButton = styled(ChromelessButton)<{$isHighlighted: boolean}>`
  height: 24px;
  border-radius: 4px;
  ${center()};
  background-color: ${(p) => (p.$isHighlighted ? p.theme.alphas.gray20 : p.theme.greys.shade20)};
  &:hover {
    background-color: ${(p) => p.theme.alphas.gray20};
  }
`;

/*
 * Component.
 */

export const InboxesSearchSuggestionsDropdownExpandButton: FC<
  InboxesSearchSuggestionsDropdownExpandButtonProps
> = ({isExpanded, onToggleExpand}) => {
  const iconName = isExpanded ? 'chevronUpSmall' : 'chevronDownSmall';
  return (
    <InteractiveListItem onSelect={onToggleExpand}>
      {({itemProps, isHighlighted}) => (
        <StyledWrapperDiv {...itemProps}>
          <StyledExpandButton $isHighlighted={isHighlighted} isOpen={isExpanded}>
            <Icon name={iconName} />
            <VisuallyHidden>
              <Trans id="searchexpandbutton">Toggle search</Trans>
            </VisuallyHidden>
          </StyledExpandButton>
        </StyledWrapperDiv>
      )}
    </InteractiveListItem>
  );
};
